<template>
  <PropertyTeam :subject="subject" />
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useRoute } from 'vue-router';

import { PropertyTeam, TeamSubject } from '@tallo/investor/property';

const route = useRoute();
const subject = computed<TeamSubject>(() => ({ kind: 'building', id: route.params.buildingId as string }));
</script>
